// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"AC-z","smallCardRow":"BC-z","largeCardRow":"CC-z","productSearchRow":"DC-z","curatedRow":"EC-z"};